import React, { useState } from "react";
import { Stepper, Step, StepLabel } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import "./Order_Tracker.css";

const useStyles = makeStyles((theme) => ({
  instructions: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

function Order_Tracker({ order, appsetup }) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(1);
  const formatDate = (dateString, addDays = 0) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    date.setDate(date.getDate() + addDays); // Add days to the date

    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }); // Example: "02 Feb 2025"
  };
  const placedOrder = order?.Order_Status_Histories?.find(
    (history) => history.order_status_id === 1
  );
  const deliveryOrder = order?.Order_Status_Histories?.find(
    (history) => history.order_status_id === 5
  );

  

  const steps = [
    {
      status: "Placed",
      date: formatDate(placedOrder?.createdAt),
      imgSrc: "/assets/Images/Icons/delivery-box.png",
    },
    {
      status: "Scheduled Delivery",
      date: order?.Order_Information?.delivery_date
        ? formatDate(order.Order_Information.delivery_date)
        : formatDate(
            placedOrder?.createdAt,
            Number(appsetup?.expected_delivery_day)
          ),

      imgSrc: "/assets/Images/Icons/delivery-men.png",
    },
  ];

  // Conditionally add the "Actual Delivered" step
  if (order?.order_status_id === 5) {
    setActiveStep(2);
    steps.push({
      status: "Actual Delivered",
      date: formatDate(deliveryOrder?.createdAt),
      imgSrc: "/assets/Images/Icons/cash-on-deliivery.png",
    });
  }

  

  return (
    <div className="Order_Tracker">
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map(({ status, date, imgSrc }, index) => (
          <Step key={index}>
            <div className="label_text_holder">
              <div className="img_holder">
                <img
                  src={process.env.PUBLIC_URL + imgSrc}
                  className="tracker_img"
                  alt="tracker_img"
                />
              </div>
              <div className="text_holder">
                <p
                  className={`main_title ${
                    index === activeStep ? "active" : ""
                  }`}
                >
                  {status}
                </p>
                <p className="subtitle">{date}</p>
              </div>
            </div>
            <StepLabel></StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
}

export default Order_Tracker;
